import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { UserUrl } from './UserUrl';
import { UserDto } from '../schema';

export interface UserSearchQueryParams {
  searchText: string;
}

const searchUsers = ({ searchText }: UserSearchQueryParams) =>
  apiClient
    .get<Array<UserDto>>(expand(UserUrl.SEARCH_NEW, { username: searchText }))
    .then((response) => response.data);

const queryKey = ['newUsersAutocomplete'] as const;

export const useSearchNewUsersQuery = createApiQueryHook(queryKey, searchUsers);

export const useRemoveSearchNewUsersQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.removeQueries({ queryKey, exact: false }),
    [queryClient]
  );
};
